import { styled } from '@mui/material/styles';
import { Box, FormControlLabel, Tab, Tabs } from '@mui/material';

export const StyledTabs = styled(Tabs)({
  minHeight: 36,
  flex: 1,
  overflow: 'visible',
  '& .MuiTabs-scroller': {
    overflow: 'visible !important'
  },
  '& .MuiTabs-indicator': {
    height: 3
  }
});

export const StyledTab = styled(Tab)(({ theme }) => ({
  minHeight: 36,
  textTransform: 'none',
  fontSize: theme.typography.body2.fontSize,
  fontWeight: theme.typography.fontWeightMedium,
  padding: theme.spacing(0.5, 2),
  overflow: 'visible',
  marginRight: theme.spacing(1)
}));

export const TabsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderBottom: `1px solid ${theme.palette.divider}`,
  padding: theme.spacing(0, 2),
  overflow: 'visible'
}));

export const TabsRightSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  gap: theme.spacing(2),
  flexShrink: 0
}));

export const HistoryToggle = styled(FormControlLabel)(({ theme }) => ({
  margin: 0,
  gap: theme.spacing(1)
}));
